export const WORK_ORDER_REVIEWS_NOTIFICATION = 'WORK_ORDER_REVIEWS_NOTIFICATION';
export const CORE_MARKET = 'CORE_MARKET';
export const DIRECT_ASSIGNMENT = 'DIRECT_ASSIGNMENT';
export const DISABLE_ISSUE_TREE = 'DISABLE_ISSUE_TREE';
export const CONFIRM_CONTACT_INFO = 'CONFIRM_CONTACT_INFO';
export const KUSTOMER_HELP = 'KUSTOMER_HELP';
export const NOTIFICATION_TEST_LIST = 'NOTIFICATION_TEST_LIST';
export const NEW_REQUEST_TRIAGE = 'NEW_REQUEST_TRIAGE';
export const VENDOR_CUSTOMERS = 'VENDOR_CUSTOMERS';
export const PARTNER_AGREEMENT = 'PARTNER_AGREEMENT';
export const QUOTE_IMPROVEMENTS = 'QUOTE_IMPROVEMENTS';
export const EQUIPMENT_SENSORS = 'EQUIPMENT_SENSORS';
export const UK_ADDRESSES = 'UK_ADDRESSES';
export const ADDRESS_VALIDATION = 'ADDRESS_VALIDATION';
export const RESQ_ON_DEMAND = 'RESQ_ON_DEMAND';
export const VENDOR_SOURCING_PARTS_ETA = 'VENDOR_SOURCING_PARTS_ETA';
export const VENDOR_ESCALATIONS = 'VENDOR_ESCALATIONS';
export const VENDOR_PLANS_V2 = 'VENDOR_PLANS_V2';
export const VULCAN_VENDOR_ONBOARDING_IMPROVEMENTS = 'VULCAN_VENDOR_ONBOARDING_IMPROVEMENTS';
export const VULCAN_INVOICE_FLAGGING = 'VULCAN_INVOICE_FLAGGING';
export const VULCAN_ONBOARDING_WELCOME_TOUR = 'VULCAN_ONBOARDING_WELCOME_TOUR';
export const STAFF_SELECT_HIDE_ADMIN = 'STAFF_SELECT_HIDE_ADMIN';
export const KUSTOMER_WORKORDER_ESCALATIONS = 'KUSTOMER_WORKORDER_ESCALATIONS';
export const INTERNAL_PREVENTATIVE_MAINTENANCE = 'INTERNAL_PREVENTATIVE_MAINTENANCE';
export const VULCAN_CYOV_CHANGES = 'VULCAN_CYOV_CHANGES';
export const VULCAN_VERIFIED_VENDOR = 'VULCAN_VERIFIED_VENDOR';
export const VULCAN_DISABLE_MARKETPLACE_PREMIUM = 'VULCAN_DISABLE_MARKETPLACE_PREMIUM';
export const AUTO_AP_BATCHING = 'AUTO_AP_BATCHING';
export const MONEY_RMC_AUTOPAY_SETTINGS = 'MONEY_RMC_AUTOPAY_SETTINGS';
